export const iconFontAwesomeFoodBeverageShrimp = (
	<i className="fa-solid fa-shrimp"></i>
);
